"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDefaultLanguage = isDefaultLanguage;
/**
 * Tells if given language is default for current tenant.
 *
 * @param language Language to be checked.
 * @returns True if given language is default for current tenant.
 */
function isDefaultLanguage(language) {
  return language.type === 'Default';
}